import React, { useEffect, useState } from "react";
import "./BoardsDetailsRecommendations.css";

const APPLICATIONS = [
  { num: "01", text: "Internal drywall partitions." },
  { num: "02", text: "Suspended ceiling systems" },
  { num: "03", text: "Wall linings to masonry or concrete substrates" },
  { num: "04", text: "Residential and commercial buildings" },
  { num: "05", text: "New build, repair, and remodeling works" },
];

const INSTALLATION_INTRO =
  "Installation shall be undertaken by trained installers in accordance with project specifications and the latest editions of ASTM C840 and GA-216 for gypsum panel application and finishing.";

const ACCORDION_ITEMS = [
  {
    id: "orientation",
    title: "Board Orientation & Layout",
    bullets: [
      "Walls: Install boards vertically (long edge parallel to studs) unless horizontal application is required by design or tested system. Stagger joints to avoid continuous weak planes",
      "Ceilings: Install boards with long edges perpendicular to framing members; offset end joints by at least one framing bay.",
      "Do not align board joints with opening corners. Keep joints at least 200 mm away from corners of cut-outs",
      "Maintain consistent board sequencing to simplify joint treatment and finishing levels.",
    ],
  },
  { id: "cutting", title: "Cutting", bullets: null },
  { id: "fastening", title: "Fastening", bullets: null },
  { id: "special", title: "Special considerations", bullets: null },
];

const BoardsDetailsRecommendations = ({ board }) => {
  const applications =
    Array.isArray(board?.recommendationApplications) && board.recommendationApplications.length
      ? board.recommendationApplications.map((item, index) => ({
          num: item?.numberLabel || String(index + 1).padStart(2, "0"),
          text: item?.text || "",
        }))
      : APPLICATIONS;

  const installationIntro = board?.recommendationsIntro || INSTALLATION_INTRO;

  const accordionItems =
    Array.isArray(board?.recommendationAccordionItems) && board.recommendationAccordionItems.length
      ? board.recommendationAccordionItems.map((item, index) => ({
          id: `api-${index}`,
          title: item?.title || "",
          bullets: Array.isArray(item?.bullets)
            ? item.bullets.map((bullet) => bullet?.text || "").filter(Boolean)
            : null,
        }))
      : ACCORDION_ITEMS;

  const [openId, setOpenId] = useState(accordionItems[0]?.id || "orientation");

  useEffect(() => {
    setOpenId(accordionItems[0]?.id || null);
  }, [board?.id]);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="boardsRec" aria-label="Recommendations">
      <div className="boardsRec-inner">
        <h2 className="boardsRec-sectionTitle">Applications</h2>

        <div className="boardsRec-appsGrid">
          {applications.map((item) => (
            <div className="boardsRec-appCard" key={item.num}>
              <span className="boardsRec-appNum">{item.num}</span>
              <p className="boardsRec-appText">{item.text}</p>
            </div>
          ))}
        </div>

        <h2 className="boardsRec-sectionTitle boardsRec-sectionTitle--spaced">
          Installation Recommendations
        </h2>

        <p className="boardsRec-intro">{installationIntro}</p>

        <div className="boardsRec-accordion" role="region" aria-label="Installation details">
          {accordionItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div className="boardsRec-accItem" key={item.id}>
                <button
                  type="button"
                  className="boardsRec-accHeader"
                  onClick={() => toggle(item.id)}
                  aria-expanded={isOpen}
                  id={`boardsRec-acc-${item.id}`}
                  aria-controls={`boardsRec-panel-${item.id}`}
                >
                  <span className="boardsRec-accTitle">{item.title}</span>
                  <span className="boardsRec-accIcon" aria-hidden>
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
                {isOpen ? (
                  <div
                    className="boardsRec-accPanel"
                    id={`boardsRec-panel-${item.id}`}
                    role="region"
                    aria-labelledby={`boardsRec-acc-${item.id}`}
                  >
                    {item.bullets?.length ? (
                      <ul className="boardsRec-accList">
                        {item.bullets.map((line, i) => (
                          <li key={i}>{line}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="boardsRec-accPlaceholder">
                        Refer to manufacturer instructions and project specifications
                        for this topic.
                      </p>
                    )}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BoardsDetailsRecommendations;
